import { SimpleTextTooltip } from "components/ui/Tooltip";
import { CircleHelpIcon, HelpCircleIcon } from "lucide-react";
import { FormattedMessage } from "react-intl";

export default function CalendarNotes() {
  return (
    <>
      <div className="col-span-full hidden md:flex">
        <SimpleTextTooltip
          className="text-xs"
          content={
            <FormattedMessage
              defaultMessage="Você pode filtrar eventos no calendário dentro do prazo de 1 ano, sendo até 6 meses no passado e até 6 meses no futuro em relação a data de hoje."
              id="ip/vS2"
              description="Agenda"
            />
          }
        >
          <span className="grid grid-flow-col gap-1 text-left font-aeonik text-xs text-gray-600 hover:cursor-pointer dark:text-slate-400 dark:hover:text-slate-300">
            <HelpCircleIcon className="size-3.5 text-gray-600 dark:text-slate-400" />
            <FormattedMessage defaultMessage="Limites de Datas no Calendário" id="HKrxWL" description="Agenda" />
          </span>
        </SimpleTextTooltip>
      </div>

      <div className="flex md:hidden">
        <SimpleTextTooltip
          className="w-full"
          content={
            <FormattedMessage
              defaultMessage="Você pode filtrar eventos no calendário dentro do prazo de 1 ano, sendo até 6 meses no passado e até 6 meses no futuro em relação a data de hoje."
              id="ip/vS2"
              description="Agenda"
            />
          }
        >
          <button
            className="m-0 flex rounded-md transition-colors hover:bg-gray-50 dark:hover:bg-slate-800"
            type="button"
          >
            <span className="grid w-full grid-flow-col gap-1 whitespace-nowrap font-aeonik text-xs text-gray-600 hover:cursor-pointer dark:text-slate-400 dark:hover:text-slate-300">
              <CircleHelpIcon className="size-3.5 text-gray-600 dark:text-slate-400" />
              <FormattedMessage defaultMessage="Limites de Datas no Calendário" id="HKrxWL" description="Agenda" />
            </span>
          </button>
        </SimpleTextTooltip>
      </div>
    </>
  );
}
